import Vue from "vue";
import { isNil } from 'lodash';
import parseDateForLocal from '../../helpers/parseDateForLocal';
import isFilledJSONValue from '../../helpers/isFilledJSONValue';
import getInputsValue from './common/getInputsValue';
import getInputsComplete from './common/getInputsComplete';
import { setDefaultInputsValues, setDefaultInputsDisabled } from './common/setDefaultInputs';
import filterDisabled from './common/filterDisabled';
import {http} from "@/axios"

function getInitState() {
  return {
    muted: false,
    saved: false,
    pendingSave: false,
    sectionId: 1,
    categories: [],
    inputs: {
      name: {
        value: null,
        required: true,
        check: (state) => {
          return isFilledJSONValue(state.inputs.name.value)
        }
      },
      profession: {
        value: null,
        required: true,
        check: (state) => {
          return !!state.inputs.profession.value
        }
      },
      categories: {
        value: [],
        required: true,
        check: (state) => {
          return !!(state.inputs.categories.value && state.inputs.categories.value.length)
        }
      },
      custom_category: {
        value: null,
      },
      quantity: {
        value: 1,
        required: false,
        check: (state) => {
          return !!state.inputs.quantity.value
        }
      },
      salary_type: {
        value: null,
        required: false,
        check: (state) => {
          return !!state.inputs.salary_type.value
        }
      },
      currency: {
        value: null,
        required: false,
        check: (state) => {
          return !!state.inputs.currency.value
        }
      },
      salary_brutto: {
        value: null,
      },
      salary: {
        value: [],
        required: true,
        check: (state) => {
          const value = state.inputs.salary.value

          if (Array.isArray(value)) {
            return Number.isFinite(parseFloat(value[0])) || Number.isFinite(parseFloat(value[1]))
          } else {
            return Number.isFinite(parseFloat(value))
          }
        }
      },
      // salary_payout_type: {
      //   value: null,
      //   required: true,
      //   check: (state) => {
      //     return !!state.inputs.salary_payout_type.value
      //   }
      // },
      salary_additional_info: {
        value: null,
        required: false,
        check: (state) => {
          return isFilledJSONValue(state.inputs.salary_additional_info.value)
        }
      },
      // work_start: {
      //   value: [],
      //   required: false,
      //   check: (state) => {
      //     const value = state.inputs.work_start.value
      //     if (Array.isArray(value)) {
      //       return value[0] || value[1]
      //     } else {
      //       return !!value
      //     }
      //   }
      // },
      work_start_text: {
        value: null,
        required: false,
        check: (state) => {
          return isFilledJSONValue(state.inputs.work_start_text.value)
        }
      },
      // work_period: {
      //   value: null,
      //   required: true,
      //   check: (state) => {
      //     return !!state.inputs.work_period.value
      //   }
      // },
      relevant: {
        value: null,
        required: false,
        check: (state) => {
          return !!state.inputs.relevant.value
        }
      },
      work_contract: {
        value: null,
        required: false,
        check: (state) => {
          return !!state.inputs.work_contract.value?.id;
        }
      },
      work_contract_subitem: {
        value: null
      },
      schedule_shift_duration: {
        value: null,
        check: (state) => {
          return !!state.inputs.schedule_shift_duration.value?.length
        }
      },
      schedule_night_shifts: {
        value: null,
        check: (state) => {
          return !isNil(state.inputs.schedule_night_shifts.value?.id);
        }
      },
      schedule_overtime_shifts: {
        value: null,
        check: (state) => {
          return !isNil(state.inputs.schedule_overtime_shifts.value?.id);
        }
      },
      schedule_additional: {
        value: null,
        check: (state) => {
          return isFilledJSONValue(state.inputs.schedule_additional.value)
        }
      },
      conditions_observation_housing: {
        value: null,
        check: (state) => {
          return !!(isFilledJSONValue(state.inputs.conditions_observation_housing.value)
            || state.inputs.conditions_observation_housing_type.value?.id)
        }
      },
      conditions_observation_housing_type: {
        value: null
      },
      conditions_housing: {
        value: null,
        check: (state) => {
          return !!(state.inputs.conditions_housing.value
              || isFilledJSONValue(state.inputs.conditions_housing_description.value)
              || state.inputs.conditions_housing_type.value?.id)
        }
      },
      conditions_housing_description: {
        value: null
      },
      conditions_housing_type: {
        value: null
      },
      conditions_meals: {
        value: null,
        check: (state) => {
          return !!(isFilledJSONValue(state.inputs.conditions_meals.value)
              || state.inputs.conditions_meals_type.value?.id)
        }
      },
      conditions_meals_type: {
        value: null
      },
      conditions_transport: {
        value: null,
        check: (state) => {
          return !!(isFilledJSONValue(state.inputs.conditions_transport.value)
              || state.inputs.conditions_transport_type.value?.id)
        }
      },
      conditions_transport_type: {
        value: null
      },
      conditions_clothes: {
        value: null,
        check: (state) => {
          return !!(isFilledJSONValue(state.inputs.conditions_clothes.value)
              || state.inputs.conditions_clothes_type.value?.id)
        }
      },
      conditions_clothes_type: {
        value: null
      },
      conditions_additional: {
        value: null,
        check: (state) => {
          return !!isFilledJSONValue(state.inputs.conditions_additional.value);
        }
      },
    },

    // - -

    observationHousingFiles: [],
    observationHousingFilesPending: false,
    observationHousingFilesEditPending: false,
    observationHousingFilesError: null,

    // - -

    housingFiles: [],
    housingFilesPending: false,
    housingFilesEditPending: false,
    housingFilesError: null,

    // - -

    transportFiles: [],
    transportFilesPending: false,
    transportFilesEditPending: false,
    transportFilesError: null,

    // - -

    clothesFiles: [],
    clothesFilesPending: false,
    clothesFilesEditPending: false,
    clothesFilesError: null,

    // - -
  }
}

export default {
  namespaced: true,
  modules: {},
  state: getInitState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return

      Vue.set(state, key, value)
    },
    setInputValue(state, [key, value]) {
      Vue.set(state.inputs[key], 'value', value)
    },
    setDefaultInputsValues,
    setDefaultInputsDisabled,
    setInputError(state, [key, error]) {
      Vue.set(state.inputs[key], 'error', error)
    },
    addCategory(state, category) {
      state.categories.push(category)
      state.inputs.categories.value.push(category)
    },
    setCategoriesByProfession(state, profession) {
      const selectedCategories = state.inputs.categories.value
      state.categories = createCategories(selectedCategories, profession)
    },
    setInputsAll(state, data) {
      const sectionData = data[1]
      state.saved = true //data.saved

      for (const key in state.inputs) {
        const inputObj = state.inputs[key]

        switch (key) {
          case 'relevant': {
            Vue.set(inputObj, 'value', parseDateForLocal(sectionData[key]))
            break
          }

          default:
            if (Array.isArray(inputObj)) {
              Vue.set(state.inputs, key, sectionData[key] || [])
            } else if (!isNil(sectionData[key])) {
              Vue.set(inputObj, 'value', sectionData[key])
            }
        }
      }

      state.categories = createCategories(sectionData.categories, sectionData.profession)

      state.observationHousingFiles = data.galleries.observation_housing_files
      state.housingFiles = data.galleries.housing_files
      state.transportFiles = data.galleries.transport_files
      state.clothesFiles = data.galleries.clothes_files
    },
    setInputDisabled(state, [key, disabled]) {
      Vue.set(state.inputs[key], 'disabled', disabled);
    },
  },
  actions: {
    uploadFilesByKey({state, commit, rootState}, [key, urlName, files]) {
      commit('setProperty', [`${key}Error`, null])
      commit('setProperty', [`${key}Pending`, true])

      const formData = new FormData()
      const {vacancy} = rootState.vacancyEdit
      const vacancyId = vacancy && vacancy.id

      files.forEach((file) => {
        formData.append(`files[]`, file)
      })

      http.post(`api/new-vacancy/${vacancyId}/${urlName}`, formData).then(({data}) => {
        const newFilesArray = state[key].concat(data.data)
        commit('setProperty', [key, newFilesArray])
      }).catch((error) => {
        commit('setProperty', [`${key}Error`, getResponseErrorMessage(error)])
      }).finally(() => {
        commit('setProperty', [`${key}Pending`, false])
      })
    },
    deleteFilesByKey({state, commit, rootState}, [key, urlName, index]) {
      commit('setProperty', [`${key}Error`, null])
      commit('setProperty', [`${key}EditPending`, true])

      const id = state[key][index].id
      const {vacancy} = rootState.vacancyEdit
      const vacancyId = vacancy && vacancy.id

      http.delete(`api/new-vacancy/${vacancyId}/${urlName}/${id}`).then(() => {
        const newFiles = state[key].filter(item => item.id !== id)
        commit('setProperty', [key, newFiles])
      }).catch((error) => {
        commit('setProperty', [`${key}Error`, getResponseErrorMessage(error)])
      }).finally(() => {
        commit('setProperty', [`${key}EditPending`, false])
      })
    },
    updateFilesByKey({state, commit, rootState}, [key, urlName, value]) {
      commit('setProperty', [`${key}Error`, null])
      commit('setProperty', [`${key}EditPending`, true])

      const prevValue = state[key]
      const {vacancy} = rootState.vacancyEdit
      const vacancyId = vacancy && vacancy.id
      const sendArray = value.map(item => {
        return {
          id: item.id,
          title: item.title
        }
      })

      commit('setProperty', [key, value])
      http.put(`api/new-vacancy/${vacancyId}/${urlName}`, sendArray).catch((error) => {
        commit('setProperty', [key, prevValue])
        commit('setProperty', [`${key}Error`, getResponseErrorMessage(error)])
      }).finally(() => {
        commit('setProperty', [`${key}EditPending`, false])
      })
    },

    setSectionErrors({state, commit}, { errors }) {
      if (typeof errors !== 'object') {
        errors = {}
      } else {
        errors = JSON.parse(JSON.stringify(errors))
      }

      for (const key in state.inputs) {

        if (Array.isArray(state.inputs[key])) {
          state.inputs[key].forEach((item, index) => {
            commit('setArrayInputError', [key, index, 'phone', errors[key]])
          })
        } else {
          commit('setInputError', [key, errors[key]])
        }

        delete errors[key];
      }
    },
  },
  getters: {
    complete(state) {
      let mustFilledCount = 0
      let filledCount = 0

      const inputs = state.inputs

      const result = getInputsComplete(state, inputs)
      mustFilledCount += result.mustFilledCount
      filledCount += result.filledCount

      return Math.round(100 / mustFilledCount * filledCount)
    },
    sendData(state) {
      const data = getInputsValue(state.inputs)

      if(data.salary) {
        if(Array.isArray(data.salary)) {
          data.salary = [
            parseFloat(data.salary[0]) || null,
            parseFloat(data.salary[1]) || null,
          ]
        } else {
          data.salary = parseFloat(data.salary) || null
        }
      }

      return filterDisabled(data, state.inputs);
    }
  }
}

function createCategories(selectedCategories = [], profession) {
  const selectedCategoriesIds = selectedCategories.map(item => item.id)

  let professionCategories = profession && profession.category.direction_categories || []
  professionCategories = professionCategories.filter(item => {
    return !selectedCategoriesIds.includes(item.id)
  })

  return [...selectedCategories, ...professionCategories]
}

function getResponseErrorMessage(error) {
  return error.response && error.response.data && error.response.data.message ||
      error.response && error.response.message ||
      error.toString()
}
